//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        is_btn: {
            type: Boolean,
            default: false
        },
        autoFocus: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false 
        }
    },
    data () {
        return {
            value: '',
        }
    },
    methods: {
        onSearch () {
            this.$emit('search', this.value)
        },
        clearInput () {
            this.value = ''
        }
    }
}
